import { Navigate } from "react-router-dom";

const SettingsReminders = () => <Navigate to="/settings/profile" replace />;

export default SettingsReminders;
